export const posts = [
  {
    title: '2025 Burning Man Essentials Packing List',
    description: 'Expanded list of must-have items to thrive in Black Rock City.',
    path: '/burning-man-2025-packing-list',
  },
  {
    title: 'Burning Man Bike Ideas',
    description: 'How to illuminate your bike and protect it from theft at Burning Man.',
    path: '/burning-man-bike-ideas',
  },
];
